import { TABLE_COLUMNS, getDisplayedOtherHoursTotal } from './constants'

/**
 * Shared "Day in Other Requests" checkbox treatment for every read-only
 * status view's "Current Request" table. Vacation Bid requests must always
 * render this column as a checked/unchecked checkbox (matching legacy),
 * never the numeric/breakdown value used for regular time-off requests.
 *
 * tableRows for these views comes from buildTableRows (constants.ts), which
 * always returns hoursInOtherRequests as a non-empty formatted string (e.g.
 * "0.00") — using its JS truthiness directly for the checkbox is always true
 * regardless of actual overlap, so the value must be parsed via
 * getDisplayedOtherHoursTotal first.
 *
 * @param tableRows - Rows as built by buildTableRows.
 * @param isVacationBidRequest - Whether the current request is a Vacation Bid.
 * @returns The table's columns, rows, and cell renderer, ready to pass
 * straight through to CurrentRequestSection.
 */
export const getVacationBidAwareTableProps = (
  tableRows: any[],
  isVacationBidRequest: boolean
) => {
  if (!isVacationBidRequest) {
    return {
      tableColumns: TABLE_COLUMNS,
      tableRows,
      renderCell: undefined,
    }
  }

  const tableColumns = TABLE_COLUMNS.map((col) =>
    col.key === 'hoursInOtherRequests'
      ? { ...col, label: 'Day in Other Requests' }
      : col
  )

  const rows = tableRows.map((row) => ({
    ...row,
    hoursInOtherRequests:
      getDisplayedOtherHoursTotal(String(row.hoursInOtherRequests ?? '')) > 0,
  }))

  const renderCell = (row: any, col: { key: string }) => {
    if (col.key !== 'hoursInOtherRequests') return row[col.key]
    if (row._totalRow || row.id === 'total') return ''
    return (
      <input
        type="checkbox"
        className="table-cell-checkbox"
        checked={!!row.hoursInOtherRequests}
        disabled
        readOnly
        aria-label="Day in other requests"
      />
    )
  }

  return { tableColumns, tableRows: rows, renderCell }
}
